console.log ("Alex Testing");
(function () {
  // Utility to extract SKU and update the Amazon link
  function updateAmazonLinkFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
console.log (variantId)
    if (!variantId || !window.ShopifyAnalytics?.meta?.product?.variants) return;

    const variants = window.ShopifyAnalytics.meta.product.variants;
    const matchedVariant = variants.find(v => String(v.id) === variantId);

    if (!matchedVariant || !matchedVariant.sku) return;

    const amazonLink = document.querySelector('#amazon-button');
    if (amazonLink && amazonLink.href) {
      amazonLink.href = amazonLink.href.replace(/\/gp\/product\/[^/]+/, `/gp/product/${matchedVariant.sku}`);
      console.log(`🔁 Amazon link updated to use ASIN ${matchedVariant.sku}`);
    }
  }

  // Run initially (on first load)
  updateAmazonLinkFromURL();

  // Helper to intercept pushState/replaceState
  const interceptHistoryMethod = (type) => {
    const original = history[type];
    history[type] = function () {
      const result = original.apply(this, arguments);
      const event = new Event('urlchange');
      window.dispatchEvent(event);
      return result;
    };
  };

  // Monkey-patch history methods
  interceptHistoryMethod('pushState');
  interceptHistoryMethod('replaceState');

  // Listen for any of these and re-run
  window.addEventListener('popstate', updateAmazonLinkFromURL);
  window.addEventListener('urlchange', updateAmazonLinkFromURL);
})();